function MenuIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.33325" y="3.33333" width="5.55556" height="5.55556" rx="1.66667" fill="#6E6864"/>
            <rect x="3.33325" y="11.1111" width="5.55556" height="5.55556" rx="1.66667" fill="#6E6864"/>
            <rect x="11.1111" y="3.33331" width="5.55556" height="5.55556" rx="1.66667" fill="#6E6864"/>
            <rect x="11.1111" y="11.1111" width="5.55556" height="5.55556" rx="1.66667" fill="#6E6864"/>
        </svg>
    );
}

export default MenuIcon;
